import { render, staticRenderFns } from "./relacaoexames.vue?vue&type=template&id=3757ccf6&scoped=true&"
import script from "./relacaoexames.vue?vue&type=script&lang=js&"
export * from "./relacaoexames.vue?vue&type=script&lang=js&"
import style0 from "./relacaoexames.vue?vue&type=style&index=0&id=3757ccf6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3757ccf6",
  null
  
)

export default component.exports